



















import { Component, Prop, Vue } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import { TextFormatting } from '@plugin/Common/mixins/TextFormatting'
import { CrossSellProductInterface } from '@plugin/Common/interfaces/cross-sell/entities/cross-sell-product.interface'
import { GA4Constants } from '@/constants/analytics-constants'
import { GA4ProductItem } from '@/classes/ga4-classes'
import { generateGA4Event, handleGA4Error } from '@/helpers/ga4-helpers'

declare global {
  interface Window {
    storeSettings: any
  }
}

@Component
export default class CrossSellMiniCartRecordComponent extends Vue {
  @Getter('products/selectedProduct') selectedProduct
  @Getter('global/getStoreData') storeData

  @Prop({ default: null })
  public record!: CrossSellProductInterface

  get hidePricing(): boolean {
    return window.storeSettings?.HidePricingOnPromotionalProductTiles
  }

  get inlineStyle(): any {
    const output = {
      backgroundImage: '',
    }
    if (this.record && this.record.imageUrl) {
      output.backgroundImage = `url(${this.record.imageUrl})`
    }
    return output
  }

  get outputPrice(): string {
    if (!this.record || !this.record.price) {
      return ''
    }
    const val = (this.record.price / 1)
      .toFixed(2)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    return `$${val}`
  }

  get productUrl(): string {
    return this.record ? this.record.url : '/'
  }

  get formattedDescription(): string {
    if (!this.record || !this.record.description) {
      return ''
    }

    const { description } = this.record
    const shortDescription = this.getShortDescription(description)
    const processedDescription = TextFormatting.methods.processStripMarkdown(shortDescription)
    return this.truncateString(processedDescription, 80)
  }

  private getShortDescription(description: string): string {
    let shortDescription = ''
    if (description) {
      if (description.indexOf('|') > -1) {
        shortDescription = description.substring(0, description.indexOf('|')).trim()
      } else {
        shortDescription = description.trim()
      }
    }
    return shortDescription
  }

  private truncateString(value: string, length: number) {
    return value.length <= length ? value : `${value.slice(0, length)} [...]`
  }

  /**
   * sendGA4CrossSellEvent()
   * Sends a GA4 select_item event using data from the selected product
   */
  async sendGA4CrossSellEvent() {
    try {
      const listId = GA4Constants.ITEM_LISTS.CROSS_SELL.ID
      const listName = GA4Constants.ITEM_LISTS.CROSS_SELL.NAME

      await this.$store.dispatch('cart/persistTempGA4Data', { id: listId, name: listName })

      const productData = {
        item_id: this.record.url.split('/').pop() || null,
        item_list_id: listId,
        item_list_name: listName,
        item_name: this.record.name,
        discount: null,
        coupon: null,
        item_category: this.record.category,
        item_category2: this.record.subcategory || null,
        item_category3: null,
        item_variant: null,
        item_brand: null,
        price: null,
        location_id: null,
        sku: null,
        affiliation: window?.storeSettings?.Store?.Name || GA4Constants.DEFAULT_AFFILIATION,
        quantity: 1,
        index: 0,
      }

      const productItem = new GA4ProductItem(productData)
      generateGA4Event({
        localStorageCartItems: [productItem],
        storeData: this.storeData,
        eventName: GA4Constants.EVENTS.SELECT_ITEM,
        localCartId: GA4Constants.LOCAL_CART_ID,
      })
    } catch (error) {
      handleGA4Error(GA4Constants.EVENTS.SELECT_ITEM, error as string, 'sendGA4CrossSellEvent()')
    }
  }
}
